import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// Do Good Candle Studio (b_3umm7l0w4u, advertiser 3706895363597287505).
// Real numbers from ANALYTICS.ADS.CAMPAIGN_PERIODS (lifetime totals over the
// complete months Apr 2024 – Aug 2026). Monthly series + partial Sep 2026 live in
// realBrandData.ts.
//
// The floor-budget archetype, and deliberately the emptiest profile in the set:
// $320 of lifetime spend, 2 conversions, 3 ad-attributed orders. Dairy Brand,
// which the prototype opens on, is $60k and 1,028. Nearly every chart on the page
// is a flat zero line under this profile — that is the point of having it, not a
// gap to be filled in.
//
// Its whole history is one month. Both conversions and all $1,167 of sales landed
// in Apr 2024; every month since has produced nothing. The brand then went dormant
// for thirteen months (May 2025 – May 2026) and restarted in Jun 2026 on fresh
// campaigns, so the current program has 0 conversions against $150 of spend.
//
// `spendingMode` is real (ADS_SERVER.ADVERTISERS.spending_mode). The advertiser is
// NON_POOLED, so `totalBudgetDollars` is the sum of the two campaign budgets
// ($150 new + $100 reorder) and `sharedBudgetDollars` is deliberately unset.
export const advDoGoodCandle: FaireAdvertiserProfileEntity = {
  token: "adv_do_good_candle",
  type: "advertiserProfile",
  archetype: "floor-budget-tiny-results",
  displayName: "Do Good Candle Studio",
  brandToken: "b_3umm7l0w4u",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 30,
  budget: {
    totalBudgetDollars: 250,
    spendingMode: "COMPETITIVE",
    nextRenewsAtDate: "2026-10-01",
    nextBillsAtDate: "2026-10-04",
  },
  overview: {
    numCustomersAcquired: 2,
    numReorderConversions: 0,
    numTotalConversions: 2,
    // `newCustomerAdsSalesDollars` is booked sales, and it happens to equal the
    // first-year projection that backs the ROAS below — the single cohort is two
    // years past its first twelve months, so the projection has resolved. Do not
    // read that coincidence as the two being the same field.
    totalAdsSalesDollars: 1167,
    newCustomerAdsSalesDollars: 1167,
    // Zero because the reorder CAMPAIGN has never booked anything. The $468
    // reorder this brand has seen belongs to the new-customer campaign's Apr 2024
    // cohort and shows up as continued sales in the month table instead.
    reorderAdsSalesDollars: 0,
    totalAdsSpendDollars: 320,
    newCustomerAdsSpendDollars: 320,
    reorderAdsSpendDollars: 0,
    newCustomerBestEstimateFirstYearRoas: 3.64,
    reorderRoas: 0,
    combinedFirstYearRoas: 3.64,
    // MANAGER_METRICS_BRAND_ORDERS: 3 orders from 2 acquired customers, all on
    // the new-customer campaign. One retailer ordered twice.
    numNewCustomerAdsOrders: 3,
    numReorderAdsOrders: 0,
  },
  availableCredit: {
    totalRemainingDollars: 0,
  },
  // MANAGER_METRICS_BRANDS, budget_status_tag "limited_20_30". Both segments read
  // MINIMUM_RECOMMENDATION_TYPE and neither is eligible for an increase, so these
  // are the floor ranges this brand is being held to rather than a prompt to
  // spend more. It is currently budgeted below both floors.
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 200,
      maxRecommendedBudgetDollars: 400,
      isEligibleForIncreaseRec: false,
    },
    reorder: {
      minRecommendedBudgetDollars: 100,
      maxRecommendedBudgetDollars: 200,
    },
  },
  campaignTokens: ["camp_dgc_new", "camp_dgc_reorder"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-21T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
